import { createSlice } from "@reduxjs/toolkit"
import { setLogin, setLogout } from "./authSlice"

const initialState = {
  userId: null,
  isComplete: false,
  ongoingRoles: [],
  ongoingRolesSaved: false,
  pastProjects: [],
  pastProjectsSaved: false,
  currentProjects: [],
  currentProjectsSaved: false,
  futureProjects: [],
  futureProjectsSaved: false,
}

export const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    resetOnboarding: () => initialState,
    completeOnboarding: state => {
      state.isComplete = true
    },
    setOngoingRoles: (state, action) => {
      state.ongoingRoles = action.payload
      state.ongoingRolesSaved = true
    },
    removeOngoingRole: (state, action) => {
      const index = action.payload
      state.ongoingRoles.splice(index, 1)
      state.ongoingRolesSaved = false
    },
    clearOngoingRoles: state => {
      state.ongoingRoles = []
      state.ongoingRolesSaved = false
    },
    setPastProjects: (state, action) => {
      state.pastProjects = action.payload
      state.pastProjectsSaved = true
    },
    removePastProject: (state, action) => {
      const index = action.payload
      state.pastProjects.splice(index, 1)
      state.pastProjectsSaved = false
    },
    clearPastProjects: state => {
      state.pastProjects = []
      state.pastProjectsSaved = false
    },
    setCurrentProjects: (state, action) => {
      state.currentProjects = action.payload
      state.currentProjectsSaved = true
    },
    removeCurrentProject: (state, action) => {
      const index = action.payload
      state.currentProjects.splice(index, 1)
      state.currentProjectsSaved = false
    },
    clearCurrentProjects: state => {
      state.currentProjects = []
      state.currentProjectsSaved = false
    },
    setFutureProjects: (state, action) => {
      state.futureProjects = action.payload
      state.futureProjectsSaved = true
    },
    removeFutureProject: (state, action) => {
      const index = action.payload
      state.futureProjects.splice(index, 1)
      state.futureProjectsSaved = false
    },
    clearFutureProjects: state => {
      state.futureProjects = []
      state.futureProjectsSaved = false
    },
  },
  extraReducers: builder => {
    builder.addCase(setLogout, () => initialState)
    builder.addCase(setLogin, (state, action) => {
      const nextUserId = action.payload?.currentUser?.id
        ? String(action.payload.currentUser.id)
        : null
      if (!nextUserId || state.userId !== nextUserId) {
        return { ...initialState, userId: nextUserId }
      }
      return state
    })
  },
})

export const {
  resetOnboarding,
  completeOnboarding,
  setOngoingRoles,
  removeOngoingRole,
  clearOngoingRoles,
  setPastProjects,
  removePastProject,
  clearPastProjects,
  setCurrentProjects,
  removeCurrentProject,
  clearCurrentProjects,
  setFutureProjects,
  removeFutureProject,
  clearFutureProjects,
} = onboardingSlice.actions

export default onboardingSlice.reducer
